import { groupLabel } from '@/components/usergroup/group'
import type { SortValues } from '@/components/search/useTableSort'
import type { Line, Rate, Statement } from './billingModel'

export const lineSortValues: SortValues<Line> = {
  machineName: row => row.machineName,
  groupName: row => row.groupName,
  from: row => row.from,
  days: row => row.days,
  rateCents: row => row.rateCents,
  vatBasisPoints: row => row.vatBasisPoints,
  netCents: row => row.netCents,
  vatCents: row => row.vatCents,
  grossCents: row => row.grossCents,
  note: row => row.note,
}
export const rateSortValues: SortValues<Rate> = {
  name: groupLabel,
  rateCents: row => row.rateCents,
}
export const statementSortValues: SortValues<Statement> = {
  start: row => row.start,
  source: row => row.source === 'manual' ? 'Na żądanie' : 'Automatyczne',
  version: row => row.version,
  netCents: row => row.netCents,
  vatCents: row => row.vatCents,
  grossCents: row => row.grossCents,
}
